import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customFn',
    standalone: false
})
export class CustomFnPipe implements PipeTransform {

    constructor() {}

    public transform(value:any, fn?:(value:any) => any): string {
        try {
            return fn(value)
        }
        catch(ex) {
            return ''
        }
    }
}